export default "__VITE_ASSET__Dl21pO20__"